const trimTrailingSlash = (value = "") => String(value).replace(/\/+$/, "");

function normalizeApiBaseUrl(value = "") {
  const normalized = trimTrailingSlash(String(value).trim());
  if (!normalized) return "";
  if (/^https?:\/\//i.test(normalized) || normalized.startsWith("/")) {
    return normalized;
  }
  if (/^(localhost|127(?:\.\d{1,3}){3})(:\d+)?$/i.test(normalized)) {
    return `http://${normalized}`;
  }
  throw new Error(
    `VUE_APP_API_BASE_URL 配置无效：${normalized}，请填写完整的 http://、https:// 或 /api 地址`
  );
}

/**
 * Allen Blog 前端唯一的后端地址配置入口。
 *
 * 开发环境默认直连本地后端，浏览器 Network 面板会明确显示 8847。
 * 生产环境默认使用同源地址，交由 Nginx 反向代理；不同部署环境可通过
 * VUE_APP_API_BASE_URL 覆盖。
 */
const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === "development" ? "http://127.0.0.1:8847" : "";

export const API_BASE_URL = normalizeApiBaseUrl(
  process.env.VUE_APP_API_BASE_URL || DEFAULT_API_BASE_URL
);
export const API_TIMEOUT = Number(process.env.VUE_APP_API_TIMEOUT) || 15000;

export const API_ENDPOINTS = Object.freeze({
  article: Object.freeze({
    list: "/article/getArticleList",
    publish: "/article/publishArticle",
    saveDraft: "/article/saveAsDraft",
    hotList: "/article/getHotArticleList",
    detail: "/article/getArticleById",
    search: "/article/searchByTitleOrContent",
    userArticles: "/article/getArticleListByUserId",
    editDetail: "/article/getArticleDetailById",
    update: "/article/updateArticleById",
    remove: "/article/delArticleById",
    liked: "/article/getUserLikedArticles",
    collected: "/article/getUserCollected",
    interaction: "/article/likeOrCollect",
    interactionState: "/article/getInteractionState",
    favorites: "/article/getMyFavoritesByUserId",
    drafts: "/article/getMyDraftsByUserId",
  }),
  category: Object.freeze({
    list: "/categoryAndTag/getCategory",
    create: "/categoryAndTag/addCategories",
    remove: "/categoryAndTag/deleteCategoryById",
  }),
  tag: Object.freeze({
    list: "/categoryAndTag/getTags",
    create: "/categoryAndTag/addTags",
    remove: "/categoryAndTag/deleteTagById",
  }),
  comment: Object.freeze({
    create: "/comment/addComment",
    articleList: "/comment/getCommentsByArticleId",
  }),
  imageWall: Object.freeze({
    list: "/img/getImgUrl",
    create: "/img/uploadImg",
    remove: "/img/delImgById",
  }),
  music: Object.freeze({
    list: "/songs/getAllMusics",
    create: "/songs/addMusic",
    update: "/songs/updateMusic",
    remove: "/songs/deleteMusic",
    detail: (id) => `/songs/${encodeURIComponent(id)}`,
    lyrics: (id) => `/songs/${encodeURIComponent(id)}/lyrics`,
  }),
  user: Object.freeze({
    register: "/user/register",
    login: "/user/login",
    update: "/user/updateUser",
    changePassword: "/user/changePassword",
    adminUsers: "/user/admin/users",
    adminAccess: "/user/admin/access",
    adminResetPassword: "/user/admin/resetPassword",
  }),
  file: Object.freeze({
    upload: "/file/upload",
    uploadAvatar: "/file/upload/avatar",
    content: (type, name) =>
      `/file/content/${encodeURIComponent(type)}/${encodeURIComponent(name)}`,
  }),
});

export function getApiOrigin() {
  const browserOrigin =
    typeof window === "undefined" ? "http://localhost" : window.location.origin;
  try {
    return trimTrailingSlash(new URL(API_BASE_URL || "/", `${browserOrigin}/`).toString());
  } catch (error) {
    return trimTrailingSlash(browserOrigin);
  }
}
